import { MultipleModalConfigs } from "features/shared/types/modal";

const ALL_MODALS_CONFIG: MultipleModalConfigs = {
    ADD: {
        headingText: "New Article",
        submitBtnText: "Add",
    },
    UPDATE: {
        headingText: "Update Article",
        submitBtnText: "Update",
    },
    VIEW: {
        headingText: "View Article",
    },
};

export default ALL_MODALS_CONFIG;
